// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1bah1h6o{justify-content:center}\n._1e0c1txw{display:flex}\n._1lve1tcg>svg{width:24px}\n._1lve7vkz>svg{width:1pc}\n._1lvezwfg>svg{width:2pc}\n._1pww1tcg>svg{height:24px}\n._1pww7vkz>svg{height:1pc}\n._1pwwzwfg>svg{height:2pc}\n._4cvr1h6o{align-items:center}", ""]);
// Exports
module.exports = exports;
